import { render, staticRenderFns } from "./JerseyQuestion.vue?vue&type=template&id=66317ed4&scoped=true&"
import script from "./JerseyQuestion.vue?vue&type=script&lang=ts&"
export * from "./JerseyQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyQuestion.vue?vue&type=style&index=0&id=66317ed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66317ed4",
  null
  
)

export default component.exports